import React from 'react';

import Header from '../Components/Dashboard/Header/Header';
import Realtime from '../Components/Dashboard/Realtime/Realtime';


export default function RealtimePage() {
  return (
    <>
      <Header/>
      <div className="body">
        <Realtime/>
      </div>
    </>
  );
}
